<template>
  <div class="space-y-1">
    <!-- Current: "bg-gray-200 text-gray-900", Default: "text-gray-700 hover:text-gray-900 hover:bg-gray-50" -->
    <a :href="this.getDashboardUrl()" class="text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium">
      <!-- Current: "text-gray-500", Default: "text-gray-400 group-hover:text-gray-500" -->
      <!-- Heroicon name: home -->
      <i class="fas fa-home text-gray-500 mr-3 text-lg"></i>
      Dashboard
    </a>

    <a v-if="user.can_view_precision_inquiries === true" href="/admin/precision-inquiries"
       class="text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium">
      <i class="fas fa-inbox text-gray-500 mr-3 text-lg" aria-hidden="true"></i>
      Precision inquiries
    </a>

<!--    <a href="#"  v-if="user.is_admin" @click="isOpen = isOpen == 1 ? !isOpen : 1 " class="block w-full text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium focus:ring-0">-->
<!--      &lt;!&ndash; Heroicon name: outline/users &ndash;&gt;-->
<!--      <i class="fas fa-cog text-gray-500 mr-3 text-lg"></i>-->
<!--      General-->
<!--      &lt;!&ndash; Expanded: "text-gray-400 rotate-90", Collapsed: "text-gray-300" &ndash;&gt;-->
<!--      <svg-->
<!--          :class="{ 'rotate-90 text-gray-400' : isOpen == 1 , 'text-gray-300' : isOpen != 1}"-->
<!--          class="ml-auto h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150" viewBox="0 0 20 20" aria-hidden="true">-->
<!--        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />-->
<!--      </svg>-->
<!--    </a>-->
<!--    &lt;!&ndash; Expandable link section, show/hide based on state. &ndash;&gt;-->
<!--    <div-->
<!--        v-if="isOpen == 1"-->
<!--        class="space-y-1">-->
<!--      <a href="/admin/representatives" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50 bg-gray-100">-->
<!--        Representatives-->
<!--      </a>-->
<!--    </div>-->

    <a href="#"
       @click="isOpen = isOpen == 2 ? !isOpen : 2 "
       class="block w-full text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium focus:ring-0">
      <!-- Heroicon name: outline/users -->
      <i class="fas fa-donate text-gray-500 mr-3 text-lg"></i>
      Financial
      <!-- Expanded: "text-gray-400 rotate-90", Collapsed: "text-gray-300" -->
      <svg
          :class="{ 'rotate-90 text-gray-400' : isOpen == 2 , 'text-gray-300' : isOpen != 2}"
          class="ml-auto h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
      </svg>
    </a>
    <!-- Expandable link section, show/hide based on state. -->
    <div
        v-if="isOpen == 2"
        class="space-y-1">
      <a href="/donation-search" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Donation Search
      </a>
      <a v-if="user.is_admin" href="/admin/deposits" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Deposits
      </a>
    </div>

    <a href="#"
       @click="isOpen = isOpen == 3 ? !isOpen : 3 "
       class="block w-full text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium focus:ring-0">
      <!-- Heroicon name: outline/users -->
      <i class="fas fa-users-cog text-gray-500 mr-3 text-lg"></i>
      Campaigns
      <!-- Expanded: "text-gray-400 rotate-90", Collapsed: "text-gray-300" -->
      <svg
          :class="{ 'rotate-90 text-gray-400' : isOpen == 3 , 'text-gray-300' : isOpen != 3}"
          class="ml-auto h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
      </svg>
    </a>
    <!-- Expandable link section, show/hide based on state. -->
    <div
        v-if="isOpen == 3"
        class="space-y-1">
      <a href="/campaign-search" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Campaign Search
      </a>
      <a v-if="user.is_admin" href="/admin/users" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        User Search
      </a>
<!--      <a href="/admin/campaign/active-foundation" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">-->
<!--        Active Campaigns-->
<!--      </a>-->
      <a v-if="user.is_admin" href="/admin/create-annual-campaign" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Create Annual Campaign
      </a>
<!--      <a href="pledge-drive-manager.php" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">-->
<!--        Pledge Drive Manager-->
<!--      </a>-->
<!--      <a href="edit-campaign.php" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">-->
<!--        Edit Fundraiser-->
<!--      </a>-->
<!--      <a href="events.php" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">-->
<!--        Events-->
<!--      </a>-->
      <a v-if="user.is_admin" href="/admin/campaign-cards" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Campaign Cards
      </a>
      <a v-if="user.is_admin" href="/admin/impact-slider" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Manage Impact Slider
      </a>
      <a v-if="user.is_admin" href="/admin/campaign/in-active-foundation" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Past Campaigns
      </a>
      <a v-if="user.is_not_admin" href="/past-campaigns" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Past Campaigns
      </a>

    </div>

    <a href="#" v-if="user.is_admin"
       @click="isOpen = isOpen == 4 ? !isOpen : 4 "
       class="block w-full text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium focus:ring-0">
      <!-- Heroicon name: outline/users -->
      <i class="fas fa-chart-bar text-gray-500 mr-3 text-lg"></i>
      Reporting
      <!-- Expanded: "text-gray-400 rotate-90", Collapsed: "text-gray-300" -->
      <svg
          :class="{ 'rotate-90 text-gray-400' : isOpen == 4 , 'text-gray-300' : isOpen != 4}"
          class="ml-auto h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
      </svg>
    </a>
    <!-- Expandable link section, show/hide based on state. -->
    <div
        v-if="isOpen == 4"
        class="space-y-1">
      <a href="/admin/reports/campaign-export" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Campaign Export
      </a>
      <a href="/admin/reports/donors-export" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Donor Export
      </a>
      <a href="/admin/reports/donations-by-state-export" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Donations By State Export
      </a>
      <a href="/admin/reports/foundation-campaign-list-for-report" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Foundation Campaign List
      </a>
      <a href="/admin/reports/impact-leaderboard" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Impact Score Leaderboard
      </a>
      <a href="/reports/campaign-stats" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Campaign Stats
      </a>
    </div>

    <a href="#" v-if="user.is_admin"
       @click="isOpen = isOpen == 5 ? !isOpen : 5 "
       class="block w-full text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium focus:ring-0">
      <!-- Salesforce Integration Icon -->
      <i class="fas fa-cloud text-gray-500 mr-3 text-lg"></i>
      Salesforce
      <!-- Expanded: "text-gray-400 rotate-90", Collapsed: "text-gray-300" -->
      <svg
          :class="{ 'rotate-90 text-gray-400' : isOpen == 5 , 'text-gray-300' : isOpen != 5}"
          class="ml-auto h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
      </svg>
    </a>
    <!-- Expandable link section, show/hide based on state. -->
    <div
        v-if="isOpen == 5"
        class="space-y-1">
      <a href="/admin/salesforce" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Configuration
      </a>
      <a href="/admin/salesforce/health-report" class="group w-full flex items-center pl-10 pr-2 py-2 text-sm text-gray-500 rounded-md hover:text-gray-900 hover:bg-gray-50">
        Health Report
      </a>
    </div>

    <a v-if="user.is_admin" href="/admin/email-composer"
       class="text-gray-700 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium">
      <i class="fas fa-envelope text-gray-500 mr-3 text-lg"></i>
      Email Composer
    </a>
  </div>
</template>

<script>
  export default {
    name: 'Navigation',
    props: {
      user: {}
    },
    data() {
      return {
        isOpen: false,
      }
    },
    methods: {
      getDashboardUrl() {
        if (this.user.is_admin) {
          return '/admin/campaign/active-foundation';
        }
        return '/active-campaigns';
      },
    },
  }
</script>

<style scoped>

</style>
